<template>
    <div class="edit">
        <div v-if="uploading" class="loader__box">
            <div class="loader__box__loader"></div>
            <h1 v-if="selected.new">Uw vacature wordt toegevoegd</h1>
            <h1 v-else>Uw vacature wordt aangepast</h1>
            <p>Een ogenblik geduld aub</p>
        </div>
        <div v-else class="edit__box">
          <div class="edit__box__titel">
              <h1 v-if="selected.titel != ''">{{ selected.titel }}</h1>
              <h1 v-else>Nieuwe vacature</h1>
              <p>Hier kan u de inhoud van de vacature aanpassen.</p>
          </div>
          <div class="edit__box__project">
              <div class="edit__box__project__wrapper">
                  <form action="">
                      <div class="form_control">
                          <label for="naam">Functie</label>
                          <input type="text" v-model="selected.titel" placeholder="Functie naam">
                      </div>
                      <div class="form_control">
                          <label for="locatie">Korte intro</label>
                          <textarea type="text" cols="30" rows="10" v-model="selected.intro" placeholder="Korte intro"></textarea>
                      </div>
                      <div class="form_control">
                          <label for="locatie">Verwachtingen</label>
                          <textarea type="text" cols="30" rows="10" v-model="selected.verwachtingen" placeholder="Verwachtingen"></textarea>
                      </div>
                      <div class="form_control">
                          <label for="naam">Persoonlijkheid</label>
                          <input type="text" v-model="selected.persoonlijkheid" placeholder="Persoonlijkheid">
                      </div>
                      <div class="form_control">
                          <label for="naam">Goals</label>
                          <input type="text" v-model="selected.goals" placeholder="Goals">
                      </div>
                      <div class="form_control">
                          <label for="naam">Verloning</label>
                          <input type="text" v-model="selected.verloning" placeholder="Verloning">
                      </div>
                      <div class="form_control">
                          <label for="naam">Groei Mogelijkheden</label>
                          <input type="text" v-model="selected.groei" placeholder="Groei mogelijkheden">
                      </div>
                      <div class="form_control">
                          <label for="beschrijving">Aanbod</label>
                          <textarea name="beschrijving" cols="30" rows="10" v-model="selected.aanbod" placeholder="Aanbod"></textarea>
                      </div>
                      <div class="form_control">
                            <label for="beschrijving">Waar kom je terecht</label>
                            <textarea name="beschrijving" cols="30" rows="10" v-model="selected.waar" placeholder="Waar kom je terecht"></textarea>
                      </div>
                      <div class="file_input">
                          <div class="form_control">
                              <label for="h-afbeelding">Afbeelding</label>
                              <input type="file" id="h-afbeelding" name="h-afbeelding" @change="addImage">
                          </div>
                      </div>
                      <div class="file_input">
                        <div class="form_control_dubbel">
                            <div class="form_control">
                                <label for="h-afbeelding">Afbeelding Sectie 1</label>
                                <input type="file" id="h-afbeelding" name="h-afbeelding" @change="imageSection1">
                            </div>
                            <div class="form_control_img">
                                <img v-if="selected.section1 == ''" src="assets/img_placeholder.png" alt="">
                                <img v-else :src="selected.section1" alt="">
                            </div>
                        </div>
                      </div>
                      <div class="file_input">
                        <div class="form_control_dubbel">
                            <div class="form_control">
                                <label for="h-afbeelding">Afbeelding Sectie 2</label>
                                <input type="file" id="h-afbeelding" name="h-afbeelding" @change="imageSection2">
                            </div>
                            <div class="form_control_img">
                                <img v-if="selected.section2 == ''" src="assets/img_placeholder.png" alt="">
                                <img v-else :src="selected.section2" alt="">
                            </div>
                        </div>
                      </div>
                     
                  </form>
                  <div class="edit__box__input__hoofdafbeelding__img">
                      <img v-if="selected.img === ''" src="assets/img_placeholder.png" alt="">
                      <img v-else :src="selected.img" alt="">
                  </div>
              </div>
              <div class="edit__box__input__buttons">
                  <p>{{ selected.edit }}</p>
                  <div class="edit__box__input__buttons__button">
                      <p class="button_2" @click="$emit('click_back')">Terug</p>
                      <p class="button" @click="saveEdit">Opslaan</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      props:["p_id"],
      inject:["data", "status"],
      data(){
          return{
              p: this.$props.p_id,
              selected: {
                  new: false,
                  id: "",
                  titel: "",
                  intro: "",
                  verwachtingen: "",
                  aanbod: "",
                  waar: "",
                  persoonlijkheid: "",
                  goals: "",
                  verloning: "",
                  groei: "",
                  img: "",
                  section1: "",
                  section2: "",
                  edit: ""
              },
              images:[],
              uploadImg: false,
              imgSection1: "",
              imgSection2: "",
              uploading: false,
          }
      },
      created(){
          if(this.p === ""){
              this.selected = {
                  new: true,
                  id: "",
                  titel: "",
                  intro: "",
                  verwachtingen: "",
                  aanbod: "",
                  waar: "Je komt terecht in een warm team van mensen die dagelijks met veel energie in het veld staan. De verloning is conform de arbeidsvoorwaarden van de sectorwerken.",
                  persoonlijkheid: "",
                  goals: "",
                  verloning: "",
                  groei: "",
                  img: "",
                  section1: "",
                  section2: "",
                  edit: ""
              }
          } else{
              this.getData();
          }
      },
      methods:{
          addImage(event){
              this.uploadImg = event.target.files;
              this.selected.img = URL.createObjectURL(event.target.files[0])
          },
          imageSection1(event){
              this.imgSection1 = event.target.files;
              this.selected.section1 = URL.createObjectURL(event.target.files[0])
          },
          imageSection2(event){
              this.imgSection2 = event.target.files;
              this.selected.section2 = URL.createObjectURL(event.target.files[0])
          },
          async getData(){
              let data;
              await axios.get(this.status.api + '/get/vacatures.php',{ 
                  params:{ 
                      userKey: this.status.userKey,
                      userMail: this.status.userMail,
                      userPass: this.status.userPass,
                      db: this.status.db,
                      id: this.p
                  }
                  }).then(function(response){
                          data = response.data;
                  }).catch(function(error){ 
                      console.log(error);
              });
              this.selected = data[0];
          },  
          async saveEdit(){
              this.uploading = true;
              let data;
              if(this.selected.new){
                  let date = new Date();
                  const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
                  let editText = "Aangemaakt op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
                  let hoofdafbeelding = "";
                  if(this.uploadImg.length === 1){
                      hoofdafbeelding = this.uploadImg[0];
                  }
                  let section1 = "";
                  if(this.imgSection1.length === 1){
                        section1 = this.imgSection1[0];
                  }
                  let section2 = "";
                  if(this.imgSection2.length === 1){
                        section2 = this.imgSection2[0];
                  }
                  await axios.post(this.status.api + '/post/new-vacature.php', {
                      server: this.status.api,
                      userKey: this.status.userKey,
                      userMail: this.status.userMail,
                      userPass: this.status.userPass,
                      db: this.status.db,
                      titel: this.selected.titel,
                      intro: this.selected.intro,
                      verwachtingen: this.selected.verwachtingen,
                      persoonlijkheid: this.selected.persoonlijkheid,
                      goals: this.selected.goals,
                      verloning: this.selected.verloning,
                      groei: this.selected.groei,
                      aanbod: this.selected.aanbod,
                      waar: this.selected.waar,
                      foto: hoofdafbeelding,
                      section1: section1,
                      section2: section2,
                      edit: editText,
                  }, {
                      headers: {'Content-Type': 'multipart/form-data'}
                  }).then(function (response) {
                      if(response.status == 200){
                          data = true
                      }
                  }).catch(function (error) {
                      console.error(error);
                  }); 
                  if(data){
                      this.$emit('click_save', 'new');
                  }
              } else {
  
                  let date = new Date();
                  const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
                  let editText = "Laatst gewijzigd op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
                  let hoofdafbeelding = "";
                  if(this.uploadImg.length === 1){
                      hoofdafbeelding = this.uploadImg[0];
                  }
                  let section1 = "";
                  if(this.imgSection1.length === 1){
                        section1 = this.imgSection1[0];
                  }
                  let section2 = "";
                  if(this.imgSection2.length === 1){
                        section2 = this.imgSection2[0];
                  }
                  await axios.post(this.status.api + '/post/edit-vacature.php', {
                      server: this.status.api,
                      userKey: this.status.userKey,
                      userMail: this.status.userMail,
                      userPass: this.status.userPass,
                      db: this.status.db,
                      id: this.selected.id,
                      titel: this.selected.titel,
                      intro: this.selected.intro,
                      verwachtingen: this.selected.verwachtingen,
                      persoonlijkheid: this.selected.persoonlijkheid,
                      goals: this.selected.goals,
                      verloning: this.selected.verloning,
                      groei: this.selected.groei,
                      aanbod: this.selected.aanbod,
                      waar: this.selected.waar,
                      foto: hoofdafbeelding,
                      section1: section1,
                      section2: section2,
                      edit: editText,
                  }, {
                      headers: {
                      'Content-Type': 'multipart/form-data'
                      }
                  }).then(function (response) {
                      if(response.status == 200){
                          data = true
                      }
                      })
                      .catch(function (error) {
                          console.error(error);
                      });
                      if(data){
                          this.$emit('click_save', 'edit');
                      }
              }
          }
      }
  }
  </script>